import { useState, useEffect } from 'react';

type ScriptStatus = 'idle' | 'loading' | 'loaded' | 'error';

const useScript = (url: string): ScriptStatus => {
  const [status, setStatus] = useState<ScriptStatus>('idle');

  useEffect(() => {
    // Check if the script is already added to the document
    const existingScript = document.querySelector(`script[src="${url}"]`);
    let script: HTMLScriptElement;
    if (existingScript) {
      // Script already exists, no need to load it again
      setStatus('loaded');
    } else {
      // Create a new script element
      script = document.createElement('script');
      script.src = url;
      script.async = true;
      // Event listener to handle script load and error events
      script.onload = () => {
        setStatus('loaded');
      };
      script.onerror = () => {
        setStatus('error');
      };
      // Add the script to the document
      document.body.appendChild(script);
      setStatus('loading');
    }

    return () => {
      // Cleanup function to remove the script when the component unmounts
      if (status === 'loading' && script) {
        // If the script is still loading, remove it
        script.remove();
      }
    };
  }, [url, status]);

  return status;
};

export default useScript;
